import * as PIXI from 'pixi.js-legacy';

const POOL_SIZE = 4;

function PixiAppPool() {
  this.pixiApps = {};
  this.availablePixiApps = []

  setInterval( () => {
    this.printStats();
  }, 5000);
}

PixiAppPool.prototype.create = function (el,  {width,height,preserveDrawingBuffer,legacy,antialias,resolution,forceFXAA}) {
  const app = new PIXI.Application({
    width,
    height,
    forceCanvas:false,
    preserveDrawingBuffer,
    transparent:false,
    legacy,
    antialias,
    resolution,
    autoResize:true,
    forceFXAA
  });

  this.availablePixiApps.push(app);

}

PixiAppPool.prototype.takeCanvas = function (key, el, {width,height,preserveDrawingBuffer,legacy,antialias,resolution,forceFXAA}, tickerFunc) {
  const app = new PIXI.Application({
    width,
    height,
    forceCanvas:true,
    preserveDrawingBuffer,
    transparent:false,
    legacy,
    antialias,
    resolution,
    autoResize:true,
    forceFXAA
  });
  let o = el.querySelectorAll('canvas');
  o = [].slice.call(o);

  o.forEach( (x) => {
    el.removeChild(x);
  })

  el.appendChild(app.view);

  if (app.view.width !== width || app.view.height !== height) {
    app.renderer.resize(width, height);
  }

  app.ticker.start();
  app.start();

  app.ticker.add( tickerFunc );

  return app;

}
PixiAppPool.prototype.releaseCanvas = function (key, el, app) {
  const stage = app.stage;

  app.ticker.stop();
  app.stop();

  for (var i = stage.children.length - 1; i >= 0; i--) {
    stage.removeChild(stage.children[i]);
  };

  app.stage = new PIXI.display.Stage();

  stage.destroy({
    children: true,
    texture: true,
    baseTexture: true
  })

}

PixiAppPool.prototype.take = function (key, el, options, tickerFunc) {
  if (!this.availablePixiApps.length) {
    if (this.availablePixiApps.length + Object.keys(this.pixiApps).length < POOL_SIZE) {
      this.create(el, options);
    } else {
      throw new Error('no pixi apps in pool');
    }
  }

  // remove old canvases that are laying around?
  let o = el.querySelectorAll('canvas');
  o = [].slice.call(o);

  o.forEach( (x) => {
    el.removeChild(x);
  })

  const app = this.availablePixiApps.pop();
  el.appendChild(app.view);

  const {width,height} = options;
  if (app.view.width !== width || app.view.height !== height) {
    app.renderer.resize(width, height);
  }
  if (this.pixiApps[key]) {
    throw new Error('lalalala');
  }
  this.pixiApps[key] = {
    tickerFunc,
    app
  };

  app.ticker.start();
  app.start();

  app.ticker.add( tickerFunc );

  this.printStats();
  return app;
}

PixiAppPool.prototype.release = function (key, el) {
  const {app,tickerFunc} = this.pixiApps[key];
  const stage = app.stage;

  app.ticker.remove(tickerFunc);
  app.ticker.stop();
  app.stop();

  for (var i = stage.children.length - 1; i >= 0; i--) {
    stage.removeChild(stage.children[i]);
  };

  app.stage = new PIXI.display.Stage();
  app.renderer.render(stage);

  stage.destroy({
    children: true,
    texture: true,
    baseTexture: true
  })

  /*
  app.destroy({
    //removeView: true,
    stageOptions: {
      children: true,
      texture: true,
      baseTexture: true
    }
  });
  */

  delete this.pixiApps[key];

  this.availablePixiApps.push(app);
  this.printStats();
}

PixiAppPool.prototype.printStats = function () {
  //console.log(`[pixiApps] poolSize=${POOL_SIZE}, inUse=${Object.keys(this.pixiApps).length}, available=${this.availablePixiApps.length}, total=${Object.keys(this.pixiApps).length + this.availablePixiApps.length}`);
}

export default PixiAppPool;
